'use strict';

var cov_4lvixuojn = function () {
	var path = '/Volumes/Data/Projects/brozeph/node-chess/src/piece.js',
	    hash = 'ef89307b0b620dae39563bb5dc93f418f75f21fc',
	    Function = function () {}.constructor,
	    global = new Function('return this')(),
	    gcv = '__coverage__',
	    coverageData = {
		path: '/Volumes/Data/Projects/brozeph/node-chess/src/piece.js',
		statementMap: {
			'0': {
				start: {
					line: 15,
					column: 23
				},
				end: {
					line: 22,
					column: 1
				}
			},
			'1': {
				start: {
					line: 24,
					column: 22
				},
				end: {
					line: 27,
					column: 1
				}
			},
			'2': {
				start: {
					line: 31,
					column: 2
				},
				end: {
					line: 31,
					column: 21
				}
			},
			'3': {
				start: {
					line: 32,
					column: 2
				},
				end: {
					line: 32,
					column: 27
				}
			},
			'4': {
				start: {
					line: 33,
					column: 2
				},
				end: {
					line: 33,
					column: 19
				}
			},
			'5': {
				start: {
					line: 34,
					column: 2
				},
				end: {
					line: 34,
					column: 19
				}
			},
			'6': {
				start: {
					line: 38,
					column: 2
				},
				end: {
					line: 38,
					column: 26
				}
			},
			'7': {
				start: {
					line: 42,
					column: 2
				},
				end: {
					line: 42,
					column: 24
				}
			},
			'8': {
				start: {
					line: 46,
					column: 2
				},
				end: {
					line: 46,
					column: 26
				}
			},
			'9': {
				start: {
					line: 50,
					column: 2
				},
				end: {
					line: 50,
					column: 24
				}
			},
			'10': {
				start: {
					line: 54,
					column: 2
				},
				end: {
					line: 54,
					column: 25
				}
			},
			'11': {
				start: {
					line: 58,
					column: 2
				},
				end: {
					line: 58,
					column: 24
				}
			},
			'12': {
				start: {
					line: 64,
					column: 2
				},
				end: {
					line: 64,
					column: 19
				}
			},
			'13': {
				start: {
					line: 66,
					column: 2
				},
				end: {
					line: 66,
					column: 31
				}
			},
			'14': {
				start: {
					line: 72,
					column: 2
				},
				end: {
					line: 72,
					column: 19
				}
			},
			'15': {
				start: {
					line: 74,
					column: 2
				},
				end: {
					line: 74,
					column: 29
				}
			},
			'16': {
				start: {
					line: 80,
					column: 2
				},
				end: {
					line: 80,
					column: 19
				}
			},
			'17': {
				start: {
					line: 82,
					column: 2
				},
				end: {
					line: 82,
					column: 31
				}
			},
			'18': {
				start: {
					line: 88,
					column: 2
				},
				end: {
					line: 88,
					column: 18
				}
			},
			'19': {
				start: {
					line: 90,
					column: 2
				},
				end: {
					line: 90,
					column: 29
				}
			},
			'20': {
				start: {
					line: 96,
					column: 2
				},
				end: {
					line: 96,
					column: 19
				}
			},
			'21': {
				start: {
					line: 98,
					column: 2
				},
				end: {
					line: 98,
					column: 30
				}
			},
			'22': {
				start: {
					line: 104,
					column: 2
				},
				end: {
					line: 104,
					column: 19
				}
			},
			'23': {
				start: {
					line: 106,
					column: 2
				},
				end: {
					line: 106,
					column: 29
				}
			}
		},
		fnMap: {
			'0': {
				name: '(anonymous_0)',
				decl: {
					start: {
						line: 30,
						column: 1
					},
					end: {
						line: 30,
						column: 2
					}
				},
				loc: {
					start: {
						line: 30,
						column: 30
					},
					end: {
						line: 35,
						column: 2
					}
				},
				line: 30
			},
			'1': {
				name: '(anonymous_1)',
				decl: {
					start: {
						line: 37,
						column: 1
					},
					end: {
						line: 37,
						column: 2
					}
				},
				loc: {
					start: {
						line: 37,
						column: 28
					},
					end: {
						line: 39,
						column: 2
					}
				},
				line: 37
			},
			'2': {
				name: '(anonymous_2)',
				decl: {
					start: {
						line: 41,
						column: 1
					},
					end: {
						line: 41,
						column: 2
					}
				},
				loc: {
					start: {
						line: 41,
						column: 26
					},
					end: {
						line: 43,
						column: 2
					}
				},
				line: 41
			},
			'3': {
				name: '(anonymous_3)',
				decl: {
					start: {
						line: 45,
						column: 1
					},
					end: {
						line: 45,
						column: 2
					}
				},
				loc: {
					start: {
						line: 45,
						column: 28
					},
					end: {
						line: 47,
						column: 2
					}
				},
				line: 45
			},
			'4': {
				name: '(anonymous_4)',
				decl: {
					start: {
						line: 49,
						column: 1
					},
					end: {
						line: 49,
						column: 2
					}
				},
				loc: {
					start: {
						line: 49,
						column: 26
					},
					end: {
						line: 51,
						column: 2
					}
				},
				line: 49
			},
			'5': {
				name: '(anonymous_5)',
				decl: {
					start: {
						line: 53,
						column: 1
					},
					end: {
						line: 53,
						column: 2
					}
				},
				loc: {
					start: {
						line: 53,
						column: 27
					},
					end: {
						line: 55,
						column: 2
					}
				},
				line: 53
			},
			'6': {
				name: '(anonymous_6)',
				decl: {
					start: {
						line: 57,
						column: 1
					},
					end: {
						line: 57,
						column: 2
					}
				},
				loc: {
					start: {
						line: 57,
						column: 26
					},
					end: {
						line: 59,
						column: 2
					}
				},
				line: 57
			},
			'7': {
				name: '(anonymous_7)',
				decl: {
					start: {
						line: 63,
						column: 1
					},
					end: {
						line: 63,
						column: 2
					}
				},
				loc: {
					start: {
						line: 63,
						column: 20
					},
					end: {
						line: 67,
						column: 2
					}
				},
				line: 63
			},
			'8': {
				name: '(anonymous_8)',
				decl: {
					start: {
						line: 71,
						column: 1
					},
					end: {
						line: 71,
						column: 2
					}
				},
				loc: {
					start: {
						line: 71,
						column: 20
					},
					end: {
						line: 75,
						column: 2
					}
				},
				line: 71
			},
			'9': {
				name: '(anonymous_9)',
				decl: {
					start: {
						line: 79,
						column: 1
					},
					end: {
						line: 79,
						column: 2
					}
				},
				loc: {
					start: {
						line: 79,
						column: 20
					},
					end: {
						line: 83,
						column: 2
					}
				},
				line: 79
			},
			'10': {
				name: '(anonymous_10)',
				decl: {
					start: {
						line: 87,
						column: 1
					},
					end: {
						line: 87,
						column: 2
					}
				},
				loc: {
					start: {
						line: 87,
						column: 20
					},
					end: {
						line: 91,
						column: 2
					}
				},
				line: 87
			},
			'11': {
				name: '(anonymous_11)',
				decl: {
					start: {
						line: 95,
						column: 1
					},
					end: {
						line: 95,
						column: 2
					}
				},
				loc: {
					start: {
						line: 95,
						column: 20
					},
					end: {
						line: 99,
						column: 2
					}
				},
				line: 95
			},
			'12': {
				name: '(anonymous_12)',
				decl: {
					start: {
						line: 103,
						column: 1
					},
					end: {
						line: 103,
						column: 2
					}
				},
				loc: {
					start: {
						line: 103,
						column: 20
					},
					end: {
						line: 107,
						column: 2
					}
				},
				line: 103
			}
		},
		branchMap: {},
		s: {
			'0': 0,
			'1': 0,
			'2': 0,
			'3': 0,
			'4': 0,
			'5': 0,
			'6': 0,
			'7': 0,
			'8': 0,
			'9': 0,
			'10': 0,
			'11': 0,
			'12': 0,
			'13': 0,
			'14': 0,
			'15': 0,
			'16': 0,
			'17': 0,
			'18': 0,
			'19': 0,
			'20': 0,
			'21': 0,
			'22': 0,
			'23': 0
		},
		f: {
			'0': 0,
			'1': 0,
			'2': 0,
			'3': 0,
			'4': 0,
			'5': 0,
			'6': 0,
			'7': 0,
			'8': 0,
			'9': 0,
			'10': 0,
			'11': 0,
			'12': 0
		},
		b: {},
		_coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
	},
	    coverage = global[gcv] || (global[gcv] = {});

	if (coverage[path] && coverage[path].hash === hash) {
		return coverage[path];
	}

	coverageData.hash = hash;
	return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
	The Piece is a definition of a piece that can be played on the board.

	The uid property of the Piece is not intended to be durable across
	sessions, but only to uniquely identify the piece on the board. Right
	now the property is used by board.getSquareByPiece as pieces are not
	otherwise uniquely identifiable (i.e. getSquareByPiece(Pawn) would
	return the first square found with a Pawn on it rather than the exact
	square intended). Additionally, the uid of the Piece is used in
	BoardValidation to ensure there is correllation between the piece and
	valid squares to which the piece can move.
*/

// types
var PieceType = exports.PieceType = (cov_4lvixuojn.s[0]++, {
	Bishop: 'bishop',
	King: 'king',
	Knight: 'knight',
	Pawn: 'pawn',
	Queen: 'queen',
	Rook: 'rook'
});

var SideType = exports.SideType = (cov_4lvixuojn.s[1]++, {
	Black: { name: 'black' },
	White: { name: 'white' }
});

var Piece = exports.Piece = function () {
	function Piece(side, notation) {
		_classCallCheck(this, Piece);

		cov_4lvixuojn.f[0]++;
		cov_4lvixuojn.s[2]++;

		this.moveCount = 0;
		cov_4lvixuojn.s[3]++;
		this.notation = notation;
		cov_4lvixuojn.s[4]++;
		this.side = side;
		cov_4lvixuojn.s[5]++;
		this.type = null;
	}

	_createClass(Piece, null, [{
		key: 'createBishop',
		value: function createBishop(side) {
			cov_4lvixuojn.f[1]++;
			cov_4lvixuojn.s[6]++;

			return new Bishop(side);
		}
	}, {
		key: 'createKing',
		value: function createKing(side) {
			cov_4lvixuojn.f[2]++;
			cov_4lvixuojn.s[7]++;

			return new King(side);
		}
	}, {
		key: 'createKnight',
		value: function createKnight(side) {
			cov_4lvixuojn.f[3]++;
			cov_4lvixuojn.s[8]++;

			return new Knight(side);
		}
	}, {
		key: 'createPawn',
		value: function createPawn(side) {
			cov_4lvixuojn.f[4]++;
			cov_4lvixuojn.s[9]++;

			return new Pawn(side);
		}
	}, {
		key: 'createQueen',
		value: function createQueen(side) {
			cov_4lvixuojn.f[5]++;
			cov_4lvixuojn.s[10]++;

			return new Queen(side);
		}
	}, {
		key: 'createRook',
		value: function createRook(side) {
			cov_4lvixuojn.f[6]++;
			cov_4lvixuojn.s[11]++;

			return new Rook(side);
		}
	}]);

	return Piece;
}();

var Bishop = exports.Bishop = function (_ref) {
	_inherits(Bishop, _ref);

	function Bishop(side) {
		_classCallCheck(this, Bishop);

		cov_4lvixuojn.f[7]++;
		cov_4lvixuojn.s[12]++;

		var _this = _possibleConstructorReturn(this, (Bishop.__proto__ || Object.getPrototypeOf(Bishop)).call(this, side, 'B'));

		cov_4lvixuojn.s[13]++;


		_this.type = PieceType.Bishop;
		return _this;
	}

	return Bishop;
}((Piece));

var King = exports.King = function (_ref2) {
	_inherits(King, _ref2);

	function King(side) {
		_classCallCheck(this, King);

		cov_4lvixuojn.f[8]++;
		cov_4lvixuojn.s[14]++;

		var _this2 = _possibleConstructorReturn(this, (King.__proto__ || Object.getPrototypeOf(King)).call(this, side, 'K'));

		cov_4lvixuojn.s[15]++;


		_this2.type = PieceType.King;
		return _this2;
	}

	return King;
}((Piece));

var Knight = exports.Knight = function (_ref3) {
	_inherits(Knight, _ref3);

	function Knight(side) {
		_classCallCheck(this, Knight);

		cov_4lvixuojn.f[9]++;
		cov_4lvixuojn.s[16]++;

		var _this3 = _possibleConstructorReturn(this, (Knight.__proto__ || Object.getPrototypeOf(Knight)).call(this, side, 'N'));

		cov_4lvixuojn.s[17]++;


		_this3.type = PieceType.Knight;
		return _this3;
	}

	return Knight;
}((Piece));

var Pawn = exports.Pawn = function (_ref4) {
	_inherits(Pawn, _ref4);

	function Pawn(side) {
		_classCallCheck(this, Pawn);

		cov_4lvixuojn.f[10]++;
		cov_4lvixuojn.s[18]++;

		var _this4 = _possibleConstructorReturn(this, (Pawn.__proto__ || Object.getPrototypeOf(Pawn)).call(this, side, ''));

		cov_4lvixuojn.s[19]++;


		_this4.type = PieceType.Pawn;
		return _this4;
	}

	return Pawn;
}((Piece));

var Queen = exports.Queen = function (_ref5) {
	_inherits(Queen, _ref5);

	function Queen(side) {
		_classCallCheck(this, Queen);

		cov_4lvixuojn.f[11]++;
		cov_4lvixuojn.s[20]++;

		var _this5 = _possibleConstructorReturn(this, (Queen.__proto__ || Object.getPrototypeOf(Queen)).call(this, side, 'Q'));

		cov_4lvixuojn.s[21]++;


		_this5.type = PieceType.Queen;
		return _this5;
	}

	return Queen;
}((Piece));

var Rook = exports.Rook = function (_ref6) {
	_inherits(Rook, _ref6);

	function Rook(side) {
		_classCallCheck(this, Rook);

		cov_4lvixuojn.f[12]++;
		cov_4lvixuojn.s[22]++;

		var _this6 = _possibleConstructorReturn(this, (Rook.__proto__ || Object.getPrototypeOf(Rook)).call(this, side, 'R'));

		cov_4lvixuojn.s[23]++;


		_this6.type = PieceType.Rook;
		return _this6;
	}

	return Rook;
}((Piece));

exports.default = {
	Piece: Piece,
	PieceType: PieceType,
	SideType: SideType
};
//# sourceMappingURL=piece.js.map
